import React, { FC, useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Node } from 'src/common/interfaces/node.interface';
import { useCurrentOrganization } from 'src/store/organization';
import { apiGetAllNodes } from 'src/utils/journeyApi';
import { FixedLoadingSpinner } from 'src/common/components/loading-spinner';
import { DashboardLibrarySyncedStepCard } from './card';
import { useFilterBarParams } from 'src/common/components/filter-bar/use-params';

type DashboardLibrarySyncedStepsProps = {};

export const DashboardLibrarySyncedSteps: FC<DashboardLibrarySyncedStepsProps> = () => {
  const { currentOrganization } = useCurrentOrganization();
  const [loading, setLoading] = useState(false);
  const [syncedSteps, setSyncedSteps] = useState<Node[]>([]);

  const {
    filterBarParams: { search_term },
  } = useFilterBarParams();

  const fetchSyncedSteps = useCallback(async () => {
    setLoading(true);
    const response = await apiGetAllNodes(currentOrganization.id, {
      is_synced: true,
      per_page: 10000,
      ...(search_term && { search_str: search_term }),
    });
    setLoading(false);
    setSyncedSteps(response.journey_nodes);
  }, [currentOrganization.id, search_term]);

  useEffect(() => {
    fetchSyncedSteps();
  }, [fetchSyncedSteps]);

  const renderContent = () => {
    if (loading) {
      return <FixedLoadingSpinner />;
    }
    if (syncedSteps.length > 0) {
      return (
        <div className='flex flex-wrap gap-4'>
          {syncedSteps.map((item) => (
            <DashboardLibrarySyncedStepCard key={item.id} node={item} onUpdate={fetchSyncedSteps} />
          ))}
        </div>
      );
    }
    // Empty
    if (search_term) {
      return <div className='text-bedrock-p text-bedrock-black'>No synced steps found</div>;
    }
    return (
      <div className='max-w-[640px] text-bedrock-p text-bedrock-black'>
        Synced Steps are Steps that remain in sync across Journeys. So if you have a calendar or a product demo that
        you're using frequently — make it a Synced Step, and then you can update all steps at once.
      </div>
    );
  };

  return (
    <div className='grow flex w-full'>
      <Helmet>
        <title>Journey | Synced Steps</title>
      </Helmet>
      {renderContent()}
    </div>
  );
};
